import React from "react";
import { useSelector } from "react-redux";



const FLOOR_LAYER_ID = 'FloorLayer';

const floorColor = 'rgba(127,127,127,0.25)';

const FloorLayer = () => {
  const storeData = useSelector((state) => state.store.storeData);

  const st = storeData?.floor_plan;

  const stw = st?.width;
  const std = st?.depth;

  return (
    <div
      id={FLOOR_LAYER_ID}
      style={{
        position: 'absolute',
        width: stw + 'px',
        height: std + 'px',
        background: floorColor,
      }}
    />
  );
};

export default FloorLayer;
